/**
 * Who may open Indstillinger → Underklinikker.
 *
 * The menu and the page use the same rule: `multi_clinic` view on a main
 * clinic. That includes clinic admins and custom roles, not only the legacy
 * `main_clinic_admin` role. Switching to a sub-clinic, or to a clinic where
 * that permission is gone, still leaves for Generelt instead of a blank or
 * error page (0328efa6).
 */
export interface SubClinicSettingsGate {
  activeClinicId: string | null;
  /** True once the active id is backed by a resolved clinic membership. */
  activeClinicResolved: boolean;
  isSubClinic: boolean;
  /** `multi_clinic` view on the active clinic. */
  canView: boolean;
}

export type SubClinicSettingsAccess = 'allow' | 'pending' | 'redirect';

export function subClinicSettingsAccess(gate: SubClinicSettingsGate): SubClinicSettingsAccess {
  if (!gate.activeClinicId) return 'redirect';
  if (!gate.activeClinicResolved) return 'pending';
  if (gate.isSubClinic || !gate.canView) return 'redirect';
  return 'allow';
}

export function leavesSubClinicSettings(access: SubClinicSettingsAccess): boolean {
  switch (access) {
    case 'redirect':
      return true;
    case 'pending':
    case 'allow':
      return false;
    default: {
      const unexpected: never = access;
      return unexpected;
    }
  }
}

/** Menu row. Stays visible while the clinic is still resolving so it does not flicker off. */
export function showSubClinicsNavItem(gate: SubClinicSettingsGate): boolean {
  if (!gate.activeClinicId || !gate.canView) return false;
  if (gate.activeClinicResolved && gate.isSubClinic) return false;
  return true;
}
